import { render, staticRenderFns } from "./PatientsByProgram.vue?vue&type=template&id=948e8650"
import script from "./PatientsByProgram.vue?vue&type=script&lang=js"
export * from "./PatientsByProgram.vue?vue&type=script&lang=js"
import style0 from "./PatientsByProgram.vue?vue&type=style&index=0&id=948e8650&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports